<template>
  <div class="flex flex-wrap sm:display-contents">
    <div
      v-for="(spec, title) in getCombinedSpeciesVisibility"
      :key="title"
      class="flex-none w-1/3 flex items-center mb-4 sm:w-full sm:-mx-3"
    >
      <div class="flex-none mr-2">
        <img :src="spec.icon" class="liveaboard-species-icon" />
      </div>

      <div class="flex-1">
        <p class="pr-3">{{ title }}</p>
        <p class="fs-14 text-black-light-5 empty-hidden -mt-1">
          {{ getVisibilityDisplay(spec.visibilityByMonth) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["destinationData", "destinationIds", "selectedTime"],
  data() {
    return {
      destinations: null,
    };
  },
  mounted() {
    if (this.destinationIds) {
      $.ajax({
        method: "POST",
        url: "/",
        data: {
          destination_ids: this.destinationIds,
          action: "zuBlu/public/getDestinationsDivingEnvironment",
          [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }).done((response) => {
        try {
          if (JSON.parse(response)) {
            this.destinations = JSON.parse(response)[this.destinationIds];
          }
        } catch (error) {}
      });
    }
  },
  computed: {
    availableMonths() {
      return [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
    },
    getCombinedSpeciesVisibility() {
      let results = {};
      if (this.destinationIds && this.destinations) {
        for (const species of this.destinations.speciesVisibility) {
          if (!species.parent) {
            continue;
          }

          if (typeof results[species.title] === "undefined") {
            results[species.title] = {
              icon: species.icon,
              visibilityByMonth: species.visibilityByMonth,
            };
          } else {
            const mergedVisibility = Object.assign(
              {},
              species.visibilityByMonth,
              results[species.title].visibilityByMonth
            );

            results[species.title].visibilityByMonth = mergedVisibility;
          }
        }
      } else if (this.destinationData) {
        for (const destinationSKU in this.destinationData) {
          for (const species of this.destinationData[destinationSKU]
            .speciesVisibility) {
            if (!species.parent) {
              continue;
            }

            if (typeof results[species.title] === "undefined") {
              results[species.title] = {
                icon: species.icon,
                visibilityByMonth: species.visibilityByMonth,
              };
            } else {
              const mergedVisibility = Object.assign(
                {},
                species.visibilityByMonth,
                results[species.title].visibilityByMonth
              );

              results[species.title].visibilityByMonth = mergedVisibility;
            }
          }
        }
      }

      return results;
    },
  },
  methods: {
    getVisibilityDisplay(visibilityByMonth) {
      const runnings = this.getRunnings(visibilityByMonth);
      return this.getMonthDisplay(runnings);
    },
    transformToFlagArray(visibilityByMonth) {
      let result = [];
      for (const month of this.availableMonths) {
        if (month in visibilityByMonth) {
          result.push(true);
        } else {
          result.push(false);
        }
      }

      return result;
    },
    getRunnings(visibilityByMonth) {
      const booleanArrays = this.transformToFlagArray(visibilityByMonth);

      let runnings = [];

      for (var i = 0; i < booleanArrays.length; ++i) {
        if (booleanArrays[i] === true) {
          let running = [];

          for (var j = i + 1; j <= booleanArrays.length; ++j) {
            running.push(i);
            i++;

            if (booleanArrays[j] === false) {
              break;
            }
          }

          runnings.push(running);
        }
      }

      if (runnings.length > 1) {
        let firstRunning = runnings[0];
        let lastRunning = runnings[runnings.length - 1];

        if (
          firstRunning[0] === 0 &&
          lastRunning[lastRunning.length - 1] === 11
        ) {
          firstRunning = lastRunning.concat(firstRunning);
        }

        runnings[0] = firstRunning;
        runnings[runnings.length - 1] = null;
        runnings = runnings.filter((r) => r);
      }

      return runnings;
    },
    getMonthDisplay(runnings) {
      const month = moment(this.selectedTime).month();
      const running = runnings.find((r) => r.includes(month));

      if (running) {
        if (running[0] === 0 && running[running.length - 1] === 11) {
          return null;
        }

        return `${this.availableMonths[running[0]]} - ${
          this.availableMonths[running[running.length - 1]]
        }`;
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.liveaboard-species-icon {
  width: 50px;
  height: 50px;
}
</style>
